import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { extractBestTranslation } from '@/utils/helpers';

function SendoutName({ row, links }) {
    const { t, i18n } = useTranslation();

    const workflowUrl = row.workflow_customer_id === null
        ? `/workflows/templates/${row.workflow_id}`
        : `/workflows/custom/${row.workflow_id}`;

    return (
        <span>
            {t('Execution of')}
            {' '}
            {links ? (
                <Link to={workflowUrl} component={RouterLink} color="inherit" onClick={(event) => event.stopPropagation()}>
                    {extractBestTranslation(row.workflow_name, i18n.language)}
                </Link>
            ) : extractBestTranslation(row.workflow_name, i18n.language)}
            {' '}
            {t('on')}
            {' '}
            {links ? (
                <Link to={`/mailinglists/${row.mailing_list_id}`} component={RouterLink} color="inherit" onClick={(event) => event.stopPropagation()}>
                    {row.mailing_list_name}
                </Link>
            ) : row.mailing_list_name}
        </span>
    )
}

export default SendoutName;